import styles from '@features/users/list/components/Table/ExternalUsersListTable.module.scss';
import { ExternalUser } from '@features/users/list/types/externalUser';

function SurnameColumnBodyTemplate(user: ExternalUser) {
  return <span className={styles.surnameColumn}>{user.surname}</span>;
}

export default SurnameColumnBodyTemplate;
